module.exports = __webpack_public_path__ + "img/w3_circle_trash_recover_white.1cb5b818.png";